import IntegerFilterField from 'components/elements/integerFilterFiled';
import { observer } from 'mobx-react';
import { Controller, useFormContext } from 'react-hook-form';
interface Props
  extends Omit<Partial<HTMLInputElement>, 'defaultValue' | 'value'> {
  name: string;
  defaultValue?: number;
  value?: number;
  data: number[];
  onChange?: (_value: number) => void;
}

function Integer({ name, defaultValue, data }: Props) {
  const methods = useFormContext();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={methods.control}
      render={({ field: { value } }) => (
        <IntegerFilterField
          isExact={methods.getValues(`${name}Exact`) || false}
          defaultValue={value}
          values={data}
          isminormax={'fromMin'}
          name={name}
          isExactName={`${name}Exact`}
        />
      )}
    />
  );
}

export default observer(Integer);
